// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-grid{
    display: grid;
    grid-gap: 50px;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    margin-bottom: 20px;
    padding: 30px;
}

.card-grid>div{
    padding: 20px;
    display: flex;
    flex-direction: column;
   
    position: relative;
    border-radius: 20px;
    min-width: 0px;
    word-wrap: break-word;
    background: #ffffff;
    -webkit-background-clip: border-box;
    background-clip: border-box;
    padding-top: 15px;
    padding-bottom: 15px;
}

dl{
    margin: 0;
}

.card-grid-2>div{
    padding: 20px;
    display: flex;
    flex-direction: column;
   
    position: relative;
    border-radius: 20px;
    min-width: 0px;
    word-wrap: break-word;
    background: #ffffff;
    -webkit-background-clip: border-box;
    background-clip: border-box;
    padding-top: 15px;
    padding-bottom: 15px;

}

.card-grid-2{
    display: grid;
    grid-gap: 50px;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    margin-bottom: 20px;
    margin-right: 30px;
    margin: 30px;
}
.revenue-div{
    display: grid;
    grid-gap: 20px;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    margin-left: 20px;
    margin-right: 20px;
    max-height: 800px;
    /* margin-bottom: 30px; */
    /* padding: 20px; */
    /* margin-top: 20px; */
}


@media screen and (min-width: 768px){
    .card-grid {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    } 
    }
@media screen and (min-width: 1440px){
.card-grid{
    grid-template-columns: repeat(5, minmax(0, 1fr));
}

/* .card-grid-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.revenue-div
{
    grid-template-columns: repeat(2, minmax(0, 1fr))
} */

}



.pie-revenue-dollar{
    color: #1B2559;
    font-size: 34px;
    text-align: start;
    font-weight: 700;
    line-height: 100%;
    margin-top: 10px;
}

.pie-revenue-dollar-name{
    color: #a3aed0;
    font-size: 0.875rem;
    font-weight: 500;
    margin-top: 4px;
    margin-inline-end: 12px;
    display: flex;
    align-items: center;
}

.billing-revenue{
    font-size: 13px;
    margin-top: 50px;
    
}

.billing-revenue>div{
    margin: 5px;
    display: flex;
    justify-content: space-between;
    color: #a3aed0;
    align-items: center;
}

.billing-revenue>div>span:nth-child(2){
    color:green
}


.table-revenue-head{
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    text-align: center;
    border-bottom: 1px solid #a3aed0;
    margin-top:20px;
    padding-bottom: 10px;
    color: #a3aed0;
    font-size: 13px;
    color: #1B2559;
    font-weight: 600;
    background: rgba(244, 247, 254, 0.2);
    border-color: transparent;
    transition-delay: 0s,0s,0s,0s;
    transition-duration: 0.25s,0.25s,0.25s,0s;
    transition-timing-function: linear,linear,linear,linear;
    filter: none;
    -webkit-backdrop-filter: blur(100px);
            backdrop-filter: blur(100px);
}
.table-revenue-body{
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    text-align: center;
    margin-top: 15px;
    margin-bottom: 15px;
    font-size: 13px;
    padding: 15px;
    background-color: #fff;
    border-radius: 25px;
   

}
.table-revenue-body>div:nth-child(1){
    color: #1B2559;
}

.table-revenue-body>div:nth-child(2){
    color: #4318FF;
}
.table-revenue-body>div:nth-child(3){
    color: #39B8FF;
}
/* 
.table-revenue-body>div:nth-child(4){
    color: #01b574;
} */
.table-revenue-body-gm-postive{
    color: #01b574; 
}

.table-revenue-body-gm-negative{
    color: rgb(236, 41, 41); 
}


.table-revenue-table::-webkit-scrollbar {
    width: 0; 
  }
  
.table-revenue-table::-webkit-scrollbar-thumb {
    background: none; 
  }

  .gm-revenue-table::-webkit-scrollbar {
    width: 0; 
  }
  
.gm-revenue-table::-webkit-scrollbar-thumb {
    background: none; 
  }


.gm-revenue-head{
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    text-align: center;
    /* border-bottom: 1px solid #a3aed0; */
    /* margin-top:20px; */
    padding-bottom: 10px;
    color: #1B2559;
    font-weight: 600;
    background: rgba(244, 247, 254, 0.2);
    border-color: transparent;
    transition-delay: 0s,0s,0s,0s;
    transition-duration: 0.25s,0.25s,0.25s,0s;
    transition-timing-function: linear,linear,linear,linear;
    filter: none;
    -webkit-backdrop-filter: blur(100px);
            backdrop-filter: blur(100px);
    /* background-color: #a3aed0; */
    margin-top: 10px;
    align-items: center;
    font-size: 16px;
    /* font-size: 10px; */
}
.gm-revenue-body{
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    text-align: center;
    margin-top: 15px;
    margin-bottom: 15px;
    font-size: 13px;
    padding: 15px;
    background-color: #fff;
    border-radius: 25px;
}

.gm-revenue-head>div{
    padding: 0px 10px;
}
.gm-revenue-body>div{
    padding: 0px 20px;
}

.gm-revenue-body>div:nth-child(1){
    color: #1B2559;
    font-weight: 600;
}

.gm-revenue-body>div:nth-child(3){
    color: #4318FF;
}
.gm-revenue-body>div:nth-child(4){
    color: #39B8FF;
}


.inhouse-revenue-head{
    display: grid;
    grid-template-columns: repeat(9, minmax(0, 1fr));
    text-align: center;
    /* border-bottom: 1px solid #a3aed0; */
    /* margin-top:20px; */
    padding-bottom: 10px;
    color: #1B2559;
    font-weight: 600;
    background: rgba(244, 247, 254, 0.2);
    border-color: transparent;
    transition-delay: 0s,0s,0s,0s;
    transition-duration: 0.25s,0.25s,0.25s,0s;
    transition-timing-function: linear,linear,linear,linear;
    filter: none;
    -webkit-backdrop-filter: blur(100px);
            backdrop-filter: blur(100px);
    /* background-color: #a3aed0; */
    margin-top: 10px;
    align-items: center;
    font-size: 16px;
}
.inhouse-revenue-body{
    display: grid;
    grid-template-columns: repeat(9, minmax(0, 1fr));
    text-align: center;
    margin-top: 15px;
    margin-bottom: 15px;
    font-size: 13px;
    padding: 15px;
    background-color: #fff;
    border-radius: 25px;
}


.inhouse-revenue-table::-webkit-scrollbar {
    width: 0; 
  }
  
.inhouse-revenue-table::-webkit-scrollbar-thumb {
    background: none; 
  }


  .inhouse-revenue-body>div:nth-child(2){
    color: #1B2559;
    font-weight: 600;
}

.inhouse-revenue-body>div:nth-child(4){
    color: #4318FF;
}
.inhouse-revenue-body>div:nth-child(5){
    color: #39B8FF;
}`, "",{"version":3,"sources":["webpack://./src/components/HomeComponents/HomeMain.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,cAAc;IACd,gDAAgD;IAChD,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IAIb,aAAa;IAGb,sBAAsB;;IAEtB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,mCAAmC;IACnC,2BAA2B;IAC3B,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,SAAS;AACb;;AAEA;IAKI,aAAa;IAIb,aAAa;IAGb,sBAAsB;;IAEtB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,mCAAmC;IACnC,2BAA2B;IAC3B,iBAAiB;IACjB;;AApBJ;;AAwBA;IACI,aAAa;IACb,cAAc;IACd,gDAAgD;IAChD,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,aAAa;IACb,cAAc;IACd,gDAAgD;IAChD,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;AAC1B;;;AAGA;IACI;QACI,gDAAgD;IACpD;IACA;AACJ;AACA;IACI,gDAAgD;AACpD;;AAEA;;;;;;;GAOG;;AAEH;;;;AAIA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IAEf,uBAAuB;IACvB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;;AAEpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI;AACJ;;;AAGA;IACI,aAAa;IACb,gDAAgD;IAChD,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,oCAAoC;IACpC,yBAAyB;IACzB,6BAA6B;IAC7B,yCAAyC;IACzC,uDAAuD;IACvD,YAAY;IACZ,oCAA4B;YAA5B,4BAA4B;AAChC;AACA;IACI,aAAa;IACb,gDAAgD;IAChD,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;;AAGvB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;;;GAGG;AACH;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,QAAQ;EACV;;AAEF;IACI,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;AAEF;IACI,gBAAgB;EAClB;;;AAGF;IACI,aAAa;IACb,gDAAgD;IAChD,kBAAkB;IAClB,sCAAsC;IACtC,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,oCAAoC;IACpC,yBAAyB;IACzB,6BAA6B;IAC7B,yCAAyC;IACzC,uDAAuD;IACvD,YAAY;IACZ,oCAA4B;YAA5B,4BAA4B;IAC5B,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,gDAAgD;IAChD,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,gDAAgD;IAChD,kBAAkB;IAClB,sCAAsC;IACtC,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,oCAAoC;IACpC,yBAAyB;IACzB,6BAA6B;IAC7B,yCAAyC;IACzC,uDAAuD;IACvD,YAAY;IACZ,oCAA4B;YAA5B,4BAA4B;IAC5B,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;IACb,gDAAgD;IAChD,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;;AAGA;IACI,QAAQ;EACV;;AAEF;IACI,gBAAgB;EAClB;;;EAGA;IACE,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB","sourcesContent":[".card-grid{\n    display: grid;\n    grid-gap: 50px;\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n    margin-bottom: 20px;\n    padding: 30px;\n}\n\n.card-grid>div{\n    padding: 20px;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n   \n    position: relative;\n    border-radius: 20px;\n    min-width: 0px;\n    word-wrap: break-word;\n    background: #ffffff;\n    -webkit-background-clip: border-box;\n    background-clip: border-box;\n    padding-top: 15px;\n    padding-bottom: 15px;\n}\n\ndl{\n    margin: 0;\n}\n\n.card-grid-2>div{\n\n}\n\n.card-grid-2>div{\n    padding: 20px;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n   \n    position: relative;\n    border-radius: 20px;\n    min-width: 0px;\n    word-wrap: break-word;\n    background: #ffffff;\n    -webkit-background-clip: border-box;\n    background-clip: border-box;\n    padding-top: 15px;\n    padding-bottom: 15px;\n   \n}\n\n.card-grid-2{\n    display: grid;\n    grid-gap: 50px;\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n    margin-bottom: 20px;\n    margin-right: 30px;\n    margin: 30px;\n}\n.revenue-div{\n    display: grid;\n    grid-gap: 20px;\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n    margin-left: 20px;\n    margin-right: 20px;\n    max-height: 800px;\n    /* margin-bottom: 30px; */\n    /* padding: 20px; */\n    /* margin-top: 20px; */\n}\n\n\n@media screen and (min-width: 768px){\n    .card-grid {\n        grid-template-columns: repeat(4, minmax(0, 1fr));\n    } \n    }\n@media screen and (min-width: 1440px){\n.card-grid{\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n\n/* .card-grid-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.revenue-div\n{\n    grid-template-columns: repeat(2, minmax(0, 1fr))\n} */\n\n}\n\n\n\n.pie-revenue-dollar{\n    color: #1B2559;\n    font-size: 34px;\n    text-align: start;\n    font-weight: 700;\n    line-height: 100%;\n    margin-top: 10px;\n}\n\n.pie-revenue-dollar-name{\n    color: #a3aed0;\n    font-size: 0.875rem;\n    font-weight: 500;\n    margin-top: 4px;\n    -webkit-margin-end: 12px;\n    margin-inline-end: 12px;\n    display: flex;\n    align-items: center;\n}\n\n.billing-revenue{\n    font-size: 13px;\n    margin-top: 50px;\n    \n}\n\n.billing-revenue>div{\n    margin: 5px;\n    display: flex;\n    justify-content: space-between;\n    color: #a3aed0;\n    align-items: center;\n}\n\n.billing-revenue>div>span:nth-child(2){\n    color:green\n}\n\n\n.table-revenue-head{\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    text-align: center;\n    border-bottom: 1px solid #a3aed0;\n    margin-top:20px;\n    padding-bottom: 10px;\n    color: #a3aed0;\n    font-size: 13px;\n    color: #1B2559;\n    font-weight: 600;\n    background: rgba(244, 247, 254, 0.2);\n    border-color: transparent;\n    transition-delay: 0s,0s,0s,0s;\n    transition-duration: 0.25s,0.25s,0.25s,0s;\n    transition-timing-function: linear,linear,linear,linear;\n    filter: none;\n    backdrop-filter: blur(100px);\n}\n.table-revenue-body{\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    text-align: center;\n    margin-top: 15px;\n    margin-bottom: 15px;\n    font-size: 13px;\n    padding: 15px;\n    background-color: #fff;\n    border-radius: 25px;\n   \n\n}\n.table-revenue-body>div:nth-child(1){\n    color: #1B2559;\n}\n\n.table-revenue-body>div:nth-child(2){\n    color: #4318FF;\n}\n.table-revenue-body>div:nth-child(3){\n    color: #39B8FF;\n}\n/* \n.table-revenue-body>div:nth-child(4){\n    color: #01b574;\n} */\n.table-revenue-body-gm-postive{\n    color: #01b574; \n}\n\n.table-revenue-body-gm-negative{\n    color: rgb(236, 41, 41); \n}\n\n\n.table-revenue-table::-webkit-scrollbar {\n    width: 0; \n  }\n  \n.table-revenue-table::-webkit-scrollbar-thumb {\n    background: none; \n  }\n\n  .gm-revenue-table::-webkit-scrollbar {\n    width: 0; \n  }\n  \n.gm-revenue-table::-webkit-scrollbar-thumb {\n    background: none; \n  }\n\n\n.gm-revenue-head{\n    display: grid;\n    grid-template-columns: repeat(7, minmax(0, 1fr));\n    text-align: center;\n    /* border-bottom: 1px solid #a3aed0; */\n    /* margin-top:20px; */\n    padding-bottom: 10px;\n    color: #1B2559;\n    font-weight: 600;\n    background: rgba(244, 247, 254, 0.2);\n    border-color: transparent;\n    transition-delay: 0s,0s,0s,0s;\n    transition-duration: 0.25s,0.25s,0.25s,0s;\n    transition-timing-function: linear,linear,linear,linear;\n    filter: none;\n    backdrop-filter: blur(100px);\n    /* background-color: #a3aed0; */\n    margin-top: 10px;\n    align-items: center;\n    font-size: 16px;\n    /* font-size: 10px; */\n}\n.gm-revenue-body{\n    display: grid;\n    grid-template-columns: repeat(7, minmax(0, 1fr));\n    text-align: center;\n    margin-top: 15px;\n    margin-bottom: 15px;\n    font-size: 13px;\n    padding: 15px;\n    background-color: #fff;\n    border-radius: 25px;\n}\n\n.gm-revenue-head>div{\n    padding: 0px 10px;\n}\n.gm-revenue-body>div{\n    padding: 0px 20px;\n}\n\n.gm-revenue-body>div:nth-child(1){\n    color: #1B2559;\n    font-weight: 600;\n}\n\n.gm-revenue-body>div:nth-child(3){\n    color: #4318FF;\n}\n.gm-revenue-body>div:nth-child(4){\n    color: #39B8FF;\n}\n\n\n.inhouse-revenue-head{\n    display: grid;\n    grid-template-columns: repeat(9, minmax(0, 1fr));\n    text-align: center;\n    /* border-bottom: 1px solid #a3aed0; */\n    /* margin-top:20px; */\n    padding-bottom: 10px;\n    color: #1B2559;\n    font-weight: 600;\n    background: rgba(244, 247, 254, 0.2);\n    border-color: transparent;\n    transition-delay: 0s,0s,0s,0s;\n    transition-duration: 0.25s,0.25s,0.25s,0s;\n    transition-timing-function: linear,linear,linear,linear;\n    filter: none;\n    backdrop-filter: blur(100px);\n    /* background-color: #a3aed0; */\n    margin-top: 10px;\n    align-items: center;\n    font-size: 16px;\n}\n.inhouse-revenue-body{\n    display: grid;\n    grid-template-columns: repeat(9, minmax(0, 1fr));\n    text-align: center;\n    margin-top: 15px;\n    margin-bottom: 15px;\n    font-size: 13px;\n    padding: 15px;\n    background-color: #fff;\n    border-radius: 25px;\n}\n\n\n.inhouse-revenue-table::-webkit-scrollbar {\n    width: 0; \n  }\n  \n.inhouse-revenue-table::-webkit-scrollbar-thumb {\n    background: none; \n  }\n\n\n  .inhouse-revenue-body>div:nth-child(2){\n    color: #1B2559;\n    font-weight: 600;\n}\n\n.inhouse-revenue-body>div:nth-child(4){\n    color: #4318FF;\n}\n.inhouse-revenue-body>div:nth-child(5){\n    color: #39B8FF;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
